<div class="center">
    <fadv-grid>
        <fadv-grid-row>
            <fadv-grid-col style="padding-bottom: 25px" alignment="center">
                <fadv-typography id="typography1" type="{{ welcomeSize }}" variant="primary">Thank you, {{this.firstName}}!!</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col alignment="center">
                <fadv-typography id="typography2">
                    <fadv-icon library='solid' name='thumbs-up' label='Bell Icon' size='xxx-large' foreground='primary'>
                    </fadv-icon>
                </fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row style="padding-top: 2%">
            <fadv-grid-col alignment="center">
                <fadv-typography id="typography3" type="{{ copyTextSize }}" variant="neutral"><strong>A representative will be in touch shortly.</strong></fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row style="padding-top: 2%">
            <fadv-grid-col alignment="center">
                    <fadv-button (click)="goHome()" name="go-home-button">Home</fadv-button>
            </fadv-grid-col>
        </fadv-grid-row>
    </fadv-grid>
